/**
 * API base URL - uses environment variable in production, relative path in development
 */
const API_BASE_URL = import.meta.env.VITE_API_URL || '';

console.log('[API] VITE_API_URL:', import.meta.env.VITE_API_URL);
console.log('[API] API_BASE_URL:', API_BASE_URL);

/**
 * Makes a fetch request to the API server
 * @param path - API endpoint path (e.g., '/data', '/posts/article.lithe')
 * @param options - Fetch options
 */
export async function apiFetch(path: string, options?: RequestInit) {
  const url = `${API_BASE_URL}${path}`;
  console.log('[API] Fetching:', url);
  return fetch(url, options);
}
